import { prisma } from "@/lib/prisma";
import type { NotificationChannel } from "@prisma/client";

// Money/date formatting lives in src/lib/settings.ts (getFormatters), bound
// to the currency + locale stored in the Setting table.

/** Turn an enum value like READY_FOR_PICKUP into "Ready For Pickup". */
export function humanize(value: string): string {
  return value
    .toLowerCase()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

/** Generate a human-friendly sequential reference, e.g. REQ-2026-000123. */
export async function nextReference(
  prefix: string,
  count: number,
  year = new Date().getFullYear()
): Promise<string> {
  return `${prefix}-${year}-${String(count + 1).padStart(6, "0")}`;
}

/** Create an in-app notification (extensible to email/SMS later). */
export async function notify(params: {
  userId: string;
  title: string;
  body?: string;
  link?: string;
  channel?: NotificationChannel;
}) {
  return prisma.notification.create({
    data: {
      userId: params.userId,
      title: params.title,
      body: params.body,
      link: params.link,
      channel: params.channel ?? "IN_APP",
    },
  });
}
